import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "pages",
  "element-loading-text": "分享中...",
  "element-loading-background": "rgba(255,255,255,0.6)"
}
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "flex items-center gap-[30px]" }
const _hoisted_4 = {
  key: 0,
  class: "actions"
}
const _hoisted_5 = {
  key: 0,
  class: "count"
}
const _hoisted_6 = { style: {"display":"flex","align-items":"center","justify-content":"center","padding":"12px"} }
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-end","gap":"10px","padding":"0 8px"} }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "item-cover" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "match-badge" }
const _hoisted_13 = { class: "cover-theme matched" }
const _hoisted_14 = { class: "item-body" }
const _hoisted_15 = { class: "templatetitle" }
const _hoisted_16 = { class: "chips" }
const _hoisted_17 = {
  key: 0,
  class: "field field-inline"
}
const _hoisted_18 = { class: "palette" }
const _hoisted_19 = { class: "metrics" }
const _hoisted_20 = { class: "metric" }
const _hoisted_21 = { class: "metric" }
const _hoisted_22 = { class: "metric" }
const _hoisted_23 = { class: "metric" }
const _hoisted_24 = { class: "metric" }

import { ref, onMounted, reactive, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { PictureFilled } from '@element-plus/icons-vue'
import { shareQrcode } from '@/api/match'
import { ElCheckboxGroup, ElCheckbox, ElCarousel, ElCarouselItem, ElTag, ElProgress, ElDialog } from 'element-plus'
//@ts-ignore
import NewLoading from '@/components/loading/loadingComp.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'result',
  props: {
    plan: {
        type: Object,
        default: () => ({})
    },
    usertype: {
        type: Number,
        default: 1
    }
},
  setup(__props) {

const textarea2 = ref('')
const selectedIdxs = ref<number[]>([])
const onSelectItem = (vals: any[]) => {
    selectAll.value = resultDataList.value.length > 0 && vals.length === resultDataList.value.length
}
const goDetail = (item: any) => { }
const selectAll = ref(false)
const toggleSelectAll = (val: boolean) => {
    if (val) {
        selectedIdxs.value = resultDataList.value.map((t: any) => t.id)
    } else {
        selectedIdxs.value = []
    }
}
const props = __props
const route = useRoute()
const shareLoading = ref(false)
const shareVisible = ref(false)
const shareImageUrl = ref('')
const resultDataList = computed(() => {
    console.log(props.plan.template_list)
    return props.plan.template_list || []
})

watch(() => props.plan && (props.plan as any).template_list, (val) => {
    // console.log('template_list updated', Array.isArray(val) ? val.length : val)

}, { immediate: true, deep: true })
const onDownloadShare = async () => {
    const url = shareImageUrl.value
    if (!url) return
    try {
        const resp = await fetch(url)
        const blob = await resp.blob()
        const a = document.createElement('a')
        const obj = URL.createObjectURL(blob)
        a.href = obj
        a.download = 'share.png'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(obj)
    } catch {
        window.open(url, '_blank')
    }
}

const onShare = async () => {
    let params = {
        match_order_id: props.plan.match_order_id,
        template_ids: selectedIdxs.value.join(',')
    }
    shareLoading.value = true
    try {
        const res = await shareQrcode(params)
        if (res?.data?.code === 200) {
            shareImageUrl.value = res?.data?.share_url || res?.data?.data?.share_url || ''
            if (shareImageUrl.value) shareVisible.value = true
        } else {
        }
    } finally {
        shareLoading.value = false
    }
    // share_url
    // const res = await shareQrcode({
    //     business_id: props.plan.id
    // })
    // if (res?.data?.code === 200) {
    //     ElMessage.success('分享成功')
    // } else {
    //     ElMessage.error(res?.data?.msg || '分享失败')
    // }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "title" }, "匹配结果", -1)),
        (props.usertype == 4)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(ElCheckbox), {
                modelValue: selectAll.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectAll).value = $event)),
                onChange: toggleSelectAll
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("全选", -1)
                ]))]),
                _: 1
              }, 8, ["modelValue"]),
              (selectedIdxs.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "已选 " + _toDisplayString(selectedIdxs.value.length), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (selectedIdxs.value.length)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: shareLoading.value,
              disabled: shareLoading.value,
              onClick: onShare
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("分享", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(ElDialog), {
      modelValue: shareVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shareVisible).value = $event)),
      title: "分享图片",
      width: "460px",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (shareVisible.value = false))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onDownloadShare
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("下载图片", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: shareImageUrl.value,
            style: {"max-width":"100%","border-radius":"8px","width":"360px","height":"360px"}
          }, null, 8, _hoisted_7)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(ElCheckboxGroup), {
      modelValue: selectedIdxs.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedIdxs).value = $event)),
      class: "result-list",
      onChange: onSelectItem
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultDataList.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id || idx,
            class: "item-card",
            onClick: ($event: any) => (goDetail(item))
          }, [
            _createElementVNode("div", {
              class: "select-checkbox",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, [
              (props.usertype == 4)
                ? (_openBlock(), _createBlock(_unref(ElCheckbox), {
                    key: 0,
                    label: item.id
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(ElCarousel), {
                class: "cover-swiper",
                interval: 3000,
                height: "260px",
                autoplay: "",
                "indicator-position": "none"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.scene_file.split(',').filter(Boolean), (img, ii) => {
                    return (_openBlock(), _createBlock(_unref(ElCarouselItem), { key: ii }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: img,
                          class: "cover-img"
                        }, null, 8, _hoisted_11)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.ui.match_percent) + "% 匹配", 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.ui.category), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(item.ui.title), 1),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ui.tags, (t, i) => {
                  return (_openBlock(), _createBlock(_unref(ElTag), {
                    key: i,
                    size: "small",
                    effect: "plain",
                    type: "success",
                    class: "chip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              (item.ui.colors && item.ui.colors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "field-label" }, "主色调", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ui.colors, (c, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "palette-swatch",
                          style: _normalizeStyle({ backgroundColor: c })
                        }, null, 4))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "metric-label" }, "类型", -1)),
                  _createVNode(_unref(ElProgress), {
                    percentage: item.scores.matchDetails.sceneType,
                    "stroke-width": 8,
                    class: "metric-progress",
                    color: "#666fff"
                  }, null, 8, ["percentage"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "metric-label" }, "主题", -1)),
                  _createVNode(_unref(ElProgress), {
                    percentage: item.scores.matchDetails.theme,
                    "stroke-width": 8,
                    class: "metric-progress",
                    color: "#f999ff"
                  }, null, 8, ["percentage"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "metric-label" }, "风格", -1)),
                  _createVNode(_unref(ElProgress), {
                    percentage: item.scores.matchDetails.style,
                    "stroke-width": 8,
                    class: "metric-progress",
                    color: "#ff9999"
                  }, null, 8, ["percentage"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "metric-label" }, "颜色", -1)),
                  _createVNode(_unref(ElProgress), {
                    percentage: item.scores.matchDetails.color,
                    "stroke-width": 8,
                    class: "metric-progress"
                  }, null, 8, ["percentage"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "metric-label" }, "物料", -1)),
                  _createVNode(_unref(ElProgress), {
                    percentage: item.scores.matchDetails.materials,
                    "stroke-width": 8,
                    class: "metric-progress",
                    color: "#ff9900"
                  }, null, 8, ["percentage"])
                ])
              ])
            ])
          ], 8, _hoisted_9))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, shareLoading.value]
  ])
}
}

})